import React from 'react';
import { IFormState } from '../Capsule';
import ServiceAccordion from '../../ServiceAccordion';
import { QuickPriceCalculatorTypeWidget } from '../../../semshared/pricelist/quickprice_widget';

interface ServiceSectionProps {
  setFormState: (formState: any) => void;
  formState: IFormState;
  serviceTypes: any[];
  quickPriceCalculator: QuickPriceCalculatorTypeWidget | null;
}

/**
 * Package selector for seminar services.
 * @param props Current form state and list of selectable service types.
 * @returns Accordion listing all service packages.
 */
const ServiceSection = ({ setFormState, formState, serviceTypes, quickPriceCalculator }: ServiceSectionProps) => {
  return (
    <>
      {serviceTypes && (
        <ServiceAccordion
          onChange={value => {
            setFormState({
              ...formState,
              service: value,
            });
          }}
          defaultValue={formState.service}
          values={serviceTypes.map((serviceType: any) => ({
            objValue: serviceType,
            value: serviceType.sku,
            content: serviceType.details,
          }))}
        />
      )}
    </>
  );
};

export default ServiceSection;
